// Imports: local files.
import {
  GET_ALL_FAQS_START,
  GET_ALL_FAQS_SUCCESS,
  GET_ALL_FAQS_FAILED,
  GET_ALL_FAQS_RESET,
  GET_ONE_FAQ_START,
  GET_ONE_FAQ_SUCCESS,
  GET_ONE_FAQ_FAILED,
  GET_ONE_FAQ_RESET,
  CREATE_FAQ_START,
  CREATE_FAQ_SUCCESS,
  CREATE_FAQ_FAILED,
  CREATE_FAQ_RESET,
  UPDATE_ONE_FAQ_START,
  UPDATE_ONE_FAQ_SUCCESS,
  UPDATE_ONE_FAQ_FAILED,
  UPDATE_ONE_FAQ_RESET,
  DELETE_ONE_FAQ_START,
  DELETE_ONE_FAQ_SUCCESS,
  DELETE_ONE_FAQ_FAILED,
  DELETE_ONE_FAQ_RESET,
} from '../actions/actions';

const initialLoadingState = {
  loading: false,
  success: false,
  data: null,
  error: false,
  errorMessage: null,
};
const initialState = {
  getAll: initialLoadingState,
  getOne: initialLoadingState,
  create: initialLoadingState,
  updateOne: initialLoadingState,
  deleteOne: initialLoadingState,
};

const faqReducer = (state = initialState, action) => {
  switch (action.type) {
    /**
     * =======================================================================
     * Get All FAQs
     * =======================================================================
     */
    case GET_ALL_FAQS_START:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_FAQS_SUCCESS:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_FAQS_FAILED:
      return { ...state, getAll: { ...action.payload } };
    case GET_ALL_FAQS_RESET:
      return { ...state, getAll: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Get One FAQ
     * =======================================================================
     */
    case GET_ONE_FAQ_START:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_FAQ_SUCCESS:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_FAQ_FAILED:
      return { ...state, getOne: { ...action.payload } };
    case GET_ONE_FAQ_RESET:
      return { ...state, getOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Create New FAQ
     * =======================================================================
     */
    case CREATE_FAQ_START:
      return { ...state, create: { ...action.payload } };
    case CREATE_FAQ_SUCCESS:
      return { ...state, create: { ...action.payload } };
    case CREATE_FAQ_FAILED:
      return { ...state, create: { ...action.payload } };
    case CREATE_FAQ_RESET:
      return { ...state, create: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Update One FAQ
     * =======================================================================
     */
    case UPDATE_ONE_FAQ_START:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_FAQ_SUCCESS:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_FAQ_FAILED:
      return { ...state, updateOne: { ...action.payload } };
    case UPDATE_ONE_FAQ_RESET:
      return { ...state, updateOne: { ...initialLoadingState } };
    /**
     * =======================================================================
     * Delete One FAQ
     * =======================================================================
     */
    case DELETE_ONE_FAQ_START:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_FAQ_SUCCESS:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_FAQ_FAILED:
      return { ...state, deleteOne: { ...action.payload } };
    case DELETE_ONE_FAQ_RESET:
      return { ...state, deleteOne: { ...initialLoadingState } };
    default:
      return state;
  }
};

export default faqReducer;
